import api from './apiLibrary';

const API = {
    getSeatGroups(params) {
        return api.get('/api/admin/seat-group', params);
    },
    createSeatGroup(data) {
        return api.post('/api/admin/seat-group', data);
    },
    editSeatGroup(id, data) {
        return api.put(`/api/admin/seat-group/${id}`, data);
    },
    getSeatGroup(id) {
        return api.get(`/api/admin/seat-group/${id}`);
    },
    deleteSeatGroup(id) {
        return api.delete(`/api/admin/seat-group/${id}`);
    },
};

export default API;
